import Alerts from '@rover/utilities/Alerts';

$(() => {
  if (!$('body').hasClass('js-premier-request')) {
    return;
  }

  const PremierRequestView = Backbone.View.extend({
    initialize() {
      this.$('.js-premier-request-form').ajaxForm({
        success: _.bind(this.success, this),
        error: _.bind(this.error, this),
      });
      this.$('#id_zip_code').on('blur', this.onPostalCodeChange.bind(this));
    },

    success(data) {
      if (data.next !== null) {
        window.location = data.next;
      }

      this.$('.js-premier-request-form-container').fadeOut(() => {
        $('html, body').animate({
          scrollTop: $('.js-premier-request-hours').offset().top,
        });
        $('.js-premier-request-confirmation').fadeIn();
      });
    },

    error() {
      Alerts.showAlert();
    },

    onPostalCodeChange(e) {
      const postalCode = e.target.value;
      const $emailOptIn = this.$('#id_email_opt_in');
      if (postalCode.match(/^[A-Z][0-9][A-Z]\s*[0-9][A-Z][0-9]$/i)) {
        $emailOptIn.prop('checked', false);
        $emailOptIn.closest('.row').removeClass('hidden');
      } else {
        $emailOptIn.prop('checked', true);
        $emailOptIn.closest('.row').addClass('hidden');
      }
    },
  });

  new PremierRequestView({
    el: '.js-premier-request',
  });
});



// WEBPACK FOOTER //
// ./js/pages/premier_request.js